const getters = {
    getFilters(state) {
        return state.filters;
    },
    getLanguage(state) {
        return state.language;
    },
}

export default getters;